<template>
  <div class="l-content">
    <div class="l-parallax">
      <div class="l-overlay"></div>
      <div class="l-logo">
        <img src="../assets/bsLogoWhite.png">
        <div class="text-quote">{{mQuote}}</div>
      </div>
      <div class="l-text">
        <div class="text-title">{{mTitle}}</div>
        <div class="text-subtitle">{{mSubtitle}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowBannerHeader',
  data () {
    return {
      mQuote: 'Simply, Better IOT',
      mTitle: 'BetterSense',
      mSubtitle: 'We turn your IOT data into intelligence\n' +
        'From any sensor on any network, get your data in one place, in real time.\n' +
        'Now is good'
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .l-debug {
    border-width: 1px;
    border-color: red;
    border-style: dashed;
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .l-content {
    position: relative;
    min-height: 860px;
  }
  .l-content .l-parallax {
    position: relative;
    min-height: 860px;
    background-image: url('../assets/bkgBanner.jpg');
    background-color: #cccccc;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .l-parallax .l-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.25;
  }
  .l-parallax .l-logo {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .l-parallax .l-logo img {
    margin-top: 2rem;
    margin-left: auto;
    margin-right: auto;
    width: 10rem;
  }
  .l-parallax .l-text {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .text-quote {
    width: 45%;
    color: #fcfcfc;
    font-weight: bold;
    margin-left: auto;
    margin-right: auto;
    margin-top: 8px
  }
  .text-title {
    color: #fcfcfc;
    font-weight: bolder;
    font-size: 5rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 420px;
  }
  .text-subtitle {
    width: 45%;
    color: #fcfcfc;
    font-weight: normal;
    font-size: large;
    margin-left: auto;
    margin-right: auto;
    margin-top: 24px
  }
  @media screen and (max-width: 768px) {
    .l-content {
      min-height: 480px;
    }
    .l-content .l-parallax {
      min-height: 480px;
      background-attachment: scroll;
    }
    .text-title {
      font-size: 3rem;
      margin-top: 260px;
    }
    .text-subtitle {
      width: 90%;
      margin-top: 18px
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RowBannerHeader.vue